export default __webpack_public_path__ + "static/media/2151.4c8eeedc.png";